import { Skeleton } from '@/components/ui/skeleton'

export const ListingDetailsLoading = () => {
	return (
		<div className='flex flex-1 flex-col overflow-hidden'>
			{/* Header */}
			<div className='border-neutral-200 border-b px-10 pt-6 pb-6'>
				<div className='flex items-center gap-4'>
					<Skeleton height={28} width={220} />
					<div className='flex items-center gap-6'>
						<Skeleton height={28} width={80} />
						<Skeleton height={28} width={120} />
					</div>
				</div>
			</div>

			{/* Content */}
			<div className='grid h-full grid-cols-[2fr_1fr] overflow-hidden pl-4'>
				{/* Photos */}
				<div className='grid h-auto grid-cols-2 overflow-auto border-neutral-200 border-r bg-neutral-50'>
					{Array.from({ length: 4 }).map((_, i) => (
						<Skeleton className='p-6' key={`photo-${i + 1}`} />
					))}
				</div>

				{/* Info panel */}
				<div className='flex flex-col gap-2 pt-6 pl-4'>
					<Skeleton height={24} width={160} />
					<div className='mt-2 flex flex-col'>
						{Array.from({ length: 7 }).map((_, i) => (
							<div
								className='grid grid-cols-[1fr_2fr] gap-4 border-neutral-200 border-b px-3 py-2.5'
								key={`info-${i + 1}`}
							>
								<Skeleton height={16} />
								<Skeleton height={16} />
							</div>
						))}
					</div>
				</div>
			</div>

			{/* Footer */}
			<div className='border-neutral-200 border-t px-10 py-4'>
				<div className='flex justify-end gap-3'>
					<Skeleton height={36} width={100} />
					<Skeleton height={36} width={100} />
				</div>
			</div>
		</div>
	)
}
